import PlaceholdersContainer from "../../../Components/UiKits/Placeholders/PlaceholdersContainer";

const Placeholders = () => {
  return <PlaceholdersContainer />;
};

export default Placeholders;
